module.exports = __webpack_public_path__ + "static/media/CB-Dragon_fireright.28c02889.png";